<div class="preview-container">
  @if (accounts.length) {
    <div class="controls">
      <p-select
        [options]="accounts"
        optionLabel="name"
        optionValue="id"
        [(ngModel)]="selectedAccountId"
        [filter]="true"
        [filterBy]="'name'"
        filterPlaceholder="Search accounts"
        [showClear]="true"
        placeholder="Select an account"
        class="wide-account-dropdown">
      </p-select>
      <button pButton type="button" label="Load Preview" icon="pi pi-search" class="p-button-secondary" (click)="loadPreview()" [disabled]="!selectedAccountId || loading"></button>
    </div>
  }

  @if (loading) {
    <p-progressSpinner></p-progressSpinner>
  }

  @if (!loading) {
    <div class="preview-content">
      @if (previewData) {
        <div class="results">
          @if (previewData?.campaigns.length) {
            <p> {{previewData?.campaigns.length}} campaign(s) found.</p>
            <ul>
              @for (campaign of previewData.campaigns; track campaign) {
                <li>
                  <i class="pi pi-bullseye icon-bullet"></i>
                  {{ campaign }}
                </li>
              }
            </ul>
          } @else {
            <p>No campaigns matched the provided selection.</p>
          }
        </div>
      }
    </div>
  }

  <div class="footer">
    <button pButton type="button" label="Close" icon="pi pi-times" class="p-button-text" (click)="close()"></button>
  </div>
</div>
